import React from 'react';

import ActiveItemMenuId from './utils/ActiveItemMenuId.enum';

const EmptyContactsGridView = ({ activeMenuItemId }) => {
	if (activeMenuItemId === ActiveItemMenuId.Selected) {
		return (
			<div className="contacts-empty-contacts-grid-view">
				<p>There are no contacts selected.</p>
			</div>
		);
	}

	return (
		<div className="contacts-empty-contacts-grid-view">
			<h1>
				You have no <b>Contacts</b> to view.
			</h1>
			<p>
				Click "Add" to add a new contact or click "Import" to import contacts
				from a file.
			</p>
		</div>
	);
};

export default EmptyContactsGridView;
